import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, XCircle, Mail, Loader } from 'lucide-react';
import API from '@/utils/api';

export default function EmailVerify() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = params.get('token');
    if (!token) { setStatus('error'); setMessage('No verification token provided.'); return; }
    API.get(`/auth/verify-email?token=${token}`)
      .then(r => { setStatus('success'); setMessage(r.data.message); })
      .catch(err => { setStatus('error'); setMessage(err.response?.data?.detail || 'Verification failed.'); });
  }, []);

  return (
    <div className="min-h-screen bg-rm-bg flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-rm-card border border-rm-border rounded-sm p-8 text-center animate-fade-in" data-testid="verify-container">
        {status === 'loading' && (
          <>
            <Loader size={48} className="text-rm-red mx-auto mb-4 animate-spin" />
            <h2 className="font-rajdhani font-bold text-2xl uppercase mb-2">Verifying Email</h2>
            <p className="text-rm-muted text-sm">Please wait...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle size={48} className="text-green-500 mx-auto mb-4" data-testid="verify-success-icon" />
            <h2 className="font-rajdhani font-bold text-2xl uppercase mb-2 text-green-500">Email Verified!</h2>
            <p className="text-rm-muted text-sm mb-6">{message}</p>
            <Link to="/auth" data-testid="verify-login-btn"
              className="inline-block btn-primary px-8 py-3 rounded-sm text-sm">
              Login to Your Account
            </Link>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle size={48} className="text-rm-red mx-auto mb-4" data-testid="verify-error-icon" />
            <h2 className="font-rajdhani font-bold text-2xl uppercase mb-2 text-rm-red">Verification Failed</h2>
            <p className="text-rm-muted text-sm mb-6">{message}</p>
            <div className="flex flex-col gap-3">
              <Link to="/auth" className="btn-primary px-8 py-3 rounded-sm text-sm block">Go to Login</Link>
              <p className="text-xs text-rm-muted">If your link expired, log in and request a new verification email.</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
